module.exports = __webpack_public_path__ + "static/media/engages-patients-anytime@3x.2918b994.png";